import { observer } from "mobx-react-lite";
import type React from "react";
import type { FunctionComponent } from "react";

export const CardTitle: FunctionComponent<React.PropsWithChildren> = observer(
  function CardTitle({ children }) {
    return (
      <div className="flex items-center py-2 mb-8">
        <h2 className="text-2xl font-bold">{children}</h2>
      </div>
    );
  },
);
